/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface VerifyChallenge403Response
 */
export interface VerifyChallenge403Response {
    /**
     * 
     * @type {string}
     * @memberof VerifyChallenge403Response
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyChallenge403Response
     */
    'reason': VerifyChallenge403ResponseReasonEnum;
}

export const VerifyChallenge403ResponseReasonEnum = {
    wrongCode: 'wrong_code',
    expired: 'expired',
    locked: 'locked',
    notPending: 'not_pending'
} as const;

export type VerifyChallenge403ResponseReasonEnum = typeof VerifyChallenge403ResponseReasonEnum[keyof typeof VerifyChallenge403ResponseReasonEnum];


